// import React from "react";
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import '../../css/SearchBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SearchBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
          selected : [],
          selectedServices : [],
          inputValue: '',
          allServicesDr: []
        }
    }

    static defaultProps = {
    datas: {},
  };


    componentDidMount() {


      var servDr = this.props.datas;
      var tabServ = [];
      var tabdr = [];
      for(var i= 0; i < servDr.length; i++){
        for(var ii= 0; ii < servDr[i].services.length; ii++){
            for (const [key, value] of Object.entries(servDr[i].services[ii])){
              if(key === "nom"){
                tabServ.push([value]);
                var nom = value;
              }
              if(key === "praticiens"){
                for (const [key, value] of Object.entries(value)){
                  tabdr.push(value.nom_alpha_num);
                }
                for (const [key, value] of Object.entries(tabServ)){
                  if(value[0] === nom){
                    tabServ[key].push([tabdr]);
                  }
                }
                tabdr = [];
              }
              }
        }
      }

      this.setState({allServicesDr: tabServ });
    }


    addSelected = (obj,key) => {
      var tabselected = this.state.selected;
      var element = document.getElementById(key+"L");

      if(tabselected.includes(obj)){
        tabselected.splice(tabselected.indexOf(obj), 1);
          element.classList.remove("is-current");
      }else {
          element.classList.add("is-current");
        tabselected.push(obj);
      }
      // this.updateStateParent('selected',tabselected,'letter');

      this.setState({selected: tabselected });
      this.props.setUpdate(tabselected,"letter");
    };

    addSelectedServices = (obj,key) => {
      var tabServices = this.state.selectedServices;
      var element = document.getElementById(obj+key+"S");

      if(tabServices.includes(obj)){
        tabServices.splice(tabServices.indexOf(obj), 1);
          element.classList.remove("is-current");
      }else {
          element.classList.add("is-current");
        tabServices.push(obj);
      }
      for (const [key, value] of Object.entries(tabServices)){
          if(!this.state.selected.includes(value.substr(0, 1))){
            tabServices.splice(value, 1);
          }
        }

        // this.updateStateParent('selectedServices',tabServices,'service');

      this.setState({selectedServices: tabServices });
      this.props.setUpdate(tabServices,"service");
    };

    _letterList = (obj) => {
    var  returnLetter = []
        for (const [key, value] of Object.entries(obj))
        {
            returnLetter.push(

              <li key={key+"L"}  onClick={() => this.addSelected(value.lettre,key)}>

                <p className="pagination-link" id={key+"L"} >{value.lettre}</p>

              </li>


            )
        }
        return returnLetter;

    }

    _reset = () => {
      const node = ReactDOM.findDOMNode(this);
        // Get child nodes
        if (node instanceof HTMLElement) {
            const child = node.querySelectorAll('.is-current');
            for (const [key, value] of Object.entries(child)){
              value.classList.remove("is-current");
              }
              const disabled = node.querySelectorAll('.disabled');
              for (const [key, value] of Object.entries(disabled)){
                value.classList.remove("disabled");
                }
        }


      var emptyTab = [];
      // console.log('jmedeclenche');
      this.props.setUpdate(emptyTab,"reset");

      this.setState({ selected: [], inputValue: '', selectedServices: [] }, () => {
        this.setState({ selected: [], inputValue: '' , selectedServices: [] });
      });


    }

    _serviceList = (obj) => {

    var  returnService = [];
    var data = this.props.datas;
        for (const [key, value] of Object.entries(obj)){
          for(var i= 0; i < data.length; i++){
            if(value === data[i].lettre){
                  for (const [key, value] of Object.entries(data[i].services)){
                  returnService.push(
                    <li key={i+key+"S"}  onClick={() => this.addSelectedServices(value.nom,key)}>

                      <p className="pagination-link" id={value.nom+key+"S"} >{value.nom}</p>

                    </li>

                  )
                }
            }
          }
        }

        return returnService;
      }

      updateInputValue = (evt) => {
        // console.log('jmedeclenche');
        this.setState({
          inputValue: evt.target.value
        });
        var disable = document.getElementById("containerLetter");
        var result = null;
        if(evt.target.value.length >= 2){
          var searchTab = this.state.allServicesDr;
          console.log(searchTab);
          var searchResult = [];
          var searchResultLetter = [];
          disable.classList.add("disabled");

          for(var i= 0; i < searchTab.length; i++){
            for(var d= 0; d < searchTab[i].length; d++){
              for(var o= 0; o < searchTab[i][1].length; o++){
                for (const [key, value] of Object.entries(searchTab[i][1][o])){

                  if(value.toLowerCase().includes(evt.target.value.toLowerCase())){
                    if(!searchResult.includes(searchTab[i][0])){
                      searchResult.push(searchTab[i][0]);
                    }
                    if(!searchResultLetter.includes(searchTab[i][0][0])){
                      searchResultLetter.push(searchTab[i][0][0]);
                    }
                  }

                  if(searchTab[i][0].toLowerCase().includes(evt.target.value.toLowerCase())){
                    if(!searchResult.includes(searchTab[i][0])){
                      searchResult.push(searchTab[i][0]);
                    }
                    if(!searchResultLetter.includes(searchTab[i][0][0])){
                      searchResultLetter.push(searchTab[i][0][0]);
                    }
                  }
                }
              }
            }
          }
          // console.log('lo');

          this.props.setUpdate(searchResultLetter,"letter");
          this.props.setUpdate(searchResult,"service");
        }else {
          disable.classList.remove("disabled");
        }
        if((searchResultLetter && searchResult) &&  (searchResultLetter.length === 0 && searchResult.length === 0)){
          result = false;
          this.props.setUpdate(result,"result");
        }else {
          result = true;

          this.props.setUpdate(result,"result");
        }


      }


  render() {

    // console.log('SearchBar this.state : ',this.state);
    // console.log('SearchBar this.props : ',this.props);


    const reset = this.state.inputValue.length >= 2 || this.state.selected.length >= 1 || this.state.selectedServices.length >= 1
      ? true
      : false;


    return (

      <div className="App containerSearchBar" >

                <div className="ScontentStyle">
                  <div className="SdivLetterStyle" id="containerLetter">
                    <nav className="pagination is-rounded" role="navigation" aria-label="pagination">
                      <ul className="pagination-list">
                        {this._letterList(this.props.datas)}
                      </ul>
                    </nav>

                    <nav className="pagination is-rounded" role="navigation" aria-label="pagination">
                      <ul className="pagination-list">
                      {this.state.selected.length >= 1 ? this._serviceList(this.state.selected) : ''}
                      </ul>
                    </nav>
                    </div>
                    <input className="input" value={this.state.inputValue} onChange={this.updateInputValue} placeholder="Nom de service / praticien"/>
                    {reset ? (

                      <div className="txt-center"><button className="button" onClick={() => this._reset()}>
                      Effacer les filtres
                        <span className="icon is-small">
                          <FontAwesomeIcon className="fas" icon="times-circle" />
                        </span>
                      </button></div>
                    ) : ''}
                </div>

      </div>


    );
  }
}
